/**
 * The base box-shadow styles for the Soft UI Dashboard PRO React.
 * You can add new box-shadow using this file.
 * You can customized the box-shadow for the entire using thie file.
 */

// Base Styles
import colors from "assets/theme/base/colors";

// Helper Functions
import boxShadow from "assets/theme/functions/boxShadow";

const { black, white, info, inputColors, tabs } = colors;

const boxShadows = {
  xs: boxShadow([0, 1], [2, 0], black.main, 0.05),
  sm: boxShadow([0, 1], [3, 0], black.main, 0.08),
  md: `${boxShadow([0, 2], [4, -1], black.light, 0.06)}, ${boxShadow(
    [0, 1],
    [2, -1],
    black.light,
    0.04
  )}`,
  lg: `${boxShadow([0, 4], [6, -2], black.light, 0.08)}, ${boxShadow(
    [0, 2],
    [4, -2],
    black.light,
    0.04
  )}`,
  xl: boxShadow([0, 8], [16, -4], black.light, 0.1),
  xxl: boxShadow([0, 12], [24, -6], black.main, 0.12),
  inset: boxShadow([0, 1], [2, 0], black.main, 0.05, "inset"),
  navbarBoxShadow: `${boxShadow([0, 1], [3, 0], black.main, 0.05)}`,
  buttonBoxShadow: {
    main: `${boxShadow([0, 1], [2, 0], black.main, 0.05)}`,
    stateOf: `${boxShadow([0, 2], [4, 0], black.main, 0.08)}`,
    stateOfNotHover: boxShadow([0, 0], [0, 0], info.main, 0),
  },
  inputBoxShadow: {
    focus: boxShadow([0, 0], [0, 2], inputColors.boxShadow, 0.5),
    error: boxShadow([0, 0], [0, 2], inputColors.error, 0.5),
    success: boxShadow([0, 0], [0, 2], inputColors.success, 0.5),
  },
  sliderBoxShadow: {
    thumb: boxShadow([0, 1], [2, 0], black.main, 0.1),
  },
  tabsBoxShadow: {
    indicator: boxShadow([0, 1], [2, 0], tabs.indicator.boxShadow, 0.5),
  },
};

export default boxShadows;
